<template>
<header class="header">
    <div class="header-left">
    <div class="brand">
        <span class="dot"></span>
         <RouterLink to="/" class="nav-link">Asso-Refuge</RouterLink>
    </div>
    </div>

    <nav class="nav" aria-label="Navigation">
      <RouterLink to="/" class="nav-link">Accueil</RouterLink>
      <RouterLink to="/animaux" class="nav-link">Animaux</RouterLink>
      <RouterLink to="/refuges" class="nav-link">Refuges</RouterLink>
      <RouterLink to="/projet" class="nav-link">Le projet</RouterLink>
      <RouterLink to="/faq" class="nav-link">F.A.Q</RouterLink>
      <a href="https://www.paypal.com/donate/?hosted_button_id=WU4SC35HMT9W2&lc=FR&locale.x=fr_FR" class="nav-link">Faire un don</a>

    </nav>

    <div class="header-right">
    <button class="btn primary">  <RouterLink to="/contact" class="nav-link">Contact</RouterLink></button>
    </div>
</header>
</template>